// ==================================================================
// Tracking Utils
// ==================================================================
export function TrackAddToWishlist(materialCode, wishlist) {
    let eventPayload = { 
        action: 'add_to_wishlist',
        wishlist_name: wishlist,
        product_id: materialCode,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }
    zaius.event('product', eventPayload);
}

export function TrackRemoveFromWishlist(materialCode, wishlist) {
    let eventPayload = { 
        action: 'remove_from_wishlist', 
        product_id: materialCode,
        wishlist_name: wishlist,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }
    zaius.event('product', eventPayload);
}

export function TrackCreateWishListFromQuickCart(materialCode, wishlist) {
    let eventPayload = { 
        action: 'create_wishlist_from_quick_cart',
        product_id: materialCode,
        wishlist_name: wishlist,
        create_wishlist_from_quick_cart_name: wishlist,
        create_wishlist_from_quick_cart_material: materialCode,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }
    zaius.event('product', eventPayload);
}

export function TrackAddFromCartToWishlist(wishlist) {
    let eventPayload = { 
        action: 'add_from_cart_to_wishlist', 
        wishlist_name: wishlist,
        product_id: wishlist,
        create_wishlist_from_cart_name: wishlist,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }
    zaius.event('product', eventPayload);
}

export function TrackAddFromWishlistToCart(wishlist) {
    let eventPayload = { 
        action: 'add_from_wishlist_to_cart', 
        wishlist_name: wishlist,
        product_id: wishlist,
        add_to_cart_from_wishlist_name: wishlist,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }
    zaius.event('product', eventPayload);
}

export function TrackAddMaterialFromWishlistToCart(wishlist, materialCode) {
    let eventPayload = { 
        action: 'add_material_from_wishlist_to_cart', 
        wishlist_name: wishlist,
        product_id: materialCode,
        add_to_cart_from_wishlist_name: wishlist,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }
    zaius.event('product', eventPayload);
}

export function TrackAddToCartFromWishlist(materialCode, wishlist) {
    let eventPayload = { 
        action: 'add_to_cart_from_wishlist',
        product_id: materialCode,
        wishlist_name: wishlist,
        create_wishlist_from_quick_cart_name: wishlist,
        create_wishlist_from_quick_cart_material: materialCode,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }
    zaius.event('product', eventPayload);
}

export function TrackAddToCart(materialCode) {
    let eventPayload = { 
        action: 'add_to_cart', 
        product_id: materialCode,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }

    zaius.event('product', eventPayload);
}

export function TrackRemoveFromCart(materialCode) {
    let eventPayload = { 
        action: 'remove_from_cart', 
        product_id: materialCode,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }

    zaius.event('product', eventPayload);
}

export function TrackAddConfiguredBundleToCart(code) {
    let eventPayload = {
        action: 'add_configured_bundle_to_cart',
        product_id: code,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }

    zaius.event('product', eventPayload);
}

export function TrackRemoveConfiguredBundleFromCart(code) {
    let eventPayload = {
        action: 'delete_configured_bundle_from_cart',
        product_id: code,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }

    zaius.event('product', eventPayload);
}

export function TrackAddBundleToCart(code) {
    let eventPayload = {
        action: 'add_bundle_to_cart',
        product_id: code,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }

    zaius.event('product', eventPayload);
}

export function TrackRemoveBundleFromCart(code) {
    let eventPayload = {
        action: 'delete_bundle_from_cart',
        product_id: code,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }

    zaius.event('product', eventPayload);
}

export function TrackAddPackageToCart(code) {
    let eventPayload = {
        action: 'add_package_to_cart',
        product_id: code,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }

    zaius.event('product', eventPayload);
}

export function TrackRemovePackageFromCart(code) {
    let eventPayload = {
        action: 'delete_package_from_cart',
        product_id: code,
        event_customer_id: GetSiteUserId(),
        event_commerce_cloud_id: GetCustomerContactId(),
        event_email: GetSiteUserEmail()
    }

    zaius.event('product', eventPayload);
}
export function TrackSearch(searchTerm,category) {
    let eventPayload = {
        action: 'search',
        search_term: searchTerm,
        category: category
    }

    zaius.event('navigation', eventPayload);
}

export function TrackSearchSorting() {
    let eventPayload = {
        action: 'sort'
    }

    zaius.event('navigation', eventPayload);
}

export function TrackSearchFilter() {
    let eventPayload = {
        action: 'filter'
    }

    zaius.event('navigation', eventPayload);
}

export function TrackLogin(email, siteUserId, customerContactId) {
    let eventPayload = {  
        action: "login",
        event_customer_id: siteUserId,
        event_commerce_cloud_id: customerContactId,
        event_email: email
    }
    
    zaius.event('customer', eventPayload);
    zaius.customer("update customer info");
}

export function TrackRegister(email, siteUserId, customerContactId) {
    let eventPayload = {  
        action: "register",
        event_customer_id: siteUserId,
        event_commerce_cloud_id: customerContactId,
        event_email: email
    }
    
    zaius.event('customer', eventPayload);
}

export function TrackCustomerInformation(email, siteUserId, customerContactId, salesOrg, distChannel, market){
    let existingUserInformation = {
        customer_id: siteUserId ? siteUserId : GetSiteUserId(),
        commerce_cloud_id: customerContactId ? customerContactId : customerContactId(),
        email: email ? email : GetSiteUserEmail()
    };
    let customUserInformation = {
        sales_organization: salesOrg ? salesOrg : GetSalesOrganization(),
        distribution_channel: distChannel ? distChannel : GetDistChannel(),
        market: market ? market : GetMarket()
    }

    zaius.customer(existingUserInformation, customUserInformation);
}

export function TrackCustomerChangeMarketInformation(marketId){
    let existingUserInformation = {
        customer_id: GetSiteUserId(),
        commerce_cloud_id: GetCustomerContactId(),
        email: GetSiteUserEmail()
    };
    let customUserInformation = {
        sales_organization: GetSalesOrganization(),
        distribution_channel: GetDistChannel(),
        market: marketId
    }

    zaius.customer(existingUserInformation, customUserInformation);
}

// ==================================================================
// DOM Utils
// ==================================================================
export function GetCustomerContactId(){
    let userIdElem = document.getElementById('user-info');

    return userIdElem.dataset.customerContactId;
}

export function GetSiteUserId(){
    let userIdElem = document.getElementById('user-info');

    return userIdElem.dataset.siteUserId;
}

export function GetSiteUserEmail(){
    let userIdElem = document.getElementById('user-info');

    return userIdElem.dataset.email;
}

export function GetSalesOrganization(){
    let userIdElem = document.getElementById('user-info');

    return userIdElem.dataset.salesOrg;
}

export function GetDistChannel(){
    let userIdElem = document.getElementById('user-info');

    return userIdElem.dataset.distChannel;
}

export function GetMarket(){
    let userIdElem = document.getElementById('user-info');

    return userIdElem.dataset.market;
}